var _rect, _text, _g, _text2, _text3, _text4, _text5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFusionImplementation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 520 120",
    role: "img",
    "aria-label": "Fusion implementation steps",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 520,
    height: 120,
    rx: 8,
    fill: "#f8fafc",
    stroke: "#e2e8f0"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 260,
    y: 18,
    textAnchor: "middle",
    fontFamily: "system-ui,sans-serif",
    fontSize: 11,
    fontWeight: 600,
    fill: "#334155"
  }, "Implement in Fusion Dev")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fontFamily: "system-ui,sans-serif",
    fontSize: 9,
    fill: "#0f172a"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 36,
    width: 108,
    height: 52,
    rx: 6,
    fill: "#fff",
    stroke: "#0891b2"
  }), /*#__PURE__*/React.createElement("text", {
    x: 74,
    y: 54,
    textAnchor: "middle",
    fontWeight: 600,
    fill: "#0e7490"
  }, "1. Navigator"), /*#__PURE__*/React.createElement("text", {
    x: 74,
    y: 68,
    textAnchor: "middle",
    fill: "#64748b"
  }, "Tools \u2192"), /*#__PURE__*/React.createElement("text", {
    x: 74,
    y: 80,
    textAnchor: "middle",
    fill: "#64748b"
  }, "Transaction Console"), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 36,
    width: 108,
    height: 52,
    rx: 6,
    fill: "#fff",
    stroke: "#0891b2"
  }), /*#__PURE__*/React.createElement("text", {
    x: 202,
    y: 54,
    textAnchor: "middle",
    fontWeight: 600,
    fill: "#0e7490"
  }, "2. Workflow"), /*#__PURE__*/React.createElement("text", {
    x: 202,
    y: 68,
    textAnchor: "middle",
    fill: "#64748b"
  }, "Manage rules"), /*#__PURE__*/React.createElement("text", {
    x: 202,
    y: 80,
    textAnchor: "middle",
    fill: "#64748b"
  }, "for transaction"), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 36,
    width: 108,
    height: 52,
    rx: 6,
    fill: "#fff",
    stroke: "#0891b2"
  }), /*#__PURE__*/React.createElement("text", {
    x: 330,
    y: 54,
    textAnchor: "middle",
    fontWeight: 600,
    fill: "#0e7490"
  }, "3. Map stages"), /*#__PURE__*/React.createElement("text", {
    x: 330,
    y: 68,
    textAnchor: "middle",
    fill: "#64748b"
  }, "Groups / roles /"), /*#__PURE__*/React.createElement("text", {
    x: 330,
    y: 80,
    textAnchor: "middle",
    fill: "#64748b"
  }, "line manager"), /*#__PURE__*/React.createElement("rect", {
    x: 404,
    y: 36,
    width: 96,
    height: 52,
    rx: 6,
    fill: "#cffafe",
    stroke: "#0891b2"
  }), /*#__PURE__*/React.createElement("text", {
    x: 452,
    y: 58,
    textAnchor: "middle",
    fontWeight: 600,
    fill: "#0e7490"
  }, "4. Test"), /*#__PURE__*/React.createElement("text", {
    x: 452,
    y: 74,
    textAnchor: "middle",
    fill: "#64748b"
  }, "BPM worklist"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 134,
    y: 64,
    fontFamily: "system-ui,sans-serif",
    fontSize: 14,
    fill: "#94a3b8"
  }, "\u2192")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 262,
    y: 64,
    fontFamily: "system-ui,sans-serif",
    fontSize: 14,
    fill: "#94a3b8"
  }, "\u2192")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 390,
    y: 64,
    fontFamily: "system-ui,sans-serif",
    fontSize: 14,
    fill: "#94a3b8"
  }, "\u2192")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 260,
    y: 108,
    textAnchor: "middle",
    fontFamily: "system-ui,sans-serif",
    fontSize: 9,
    fill: "#64748b"
  }, "Use generated JSON + checklist below as your build guide")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFusionImplementation);
export default __webpack_public_path__ + "static/media/fusion-implementation.4aff899c39af240b8ad8577534123fde.svg";
export { ForwardRef as ReactComponent };